import { inject, Injectable } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { getIdTokenResult } from 'firebase/auth';

/**
 * Platform admin is the `admin: true` custom claim on the Firebase ID token
 * (HMM-283). firestore.rules, storage.rules and the admin callables all read
 * that claim, so the client must gate admin routes on the same thing —
 * `users/{uid}.role` is only a display mirror.
 */
@Injectable({ providedIn: 'root' })
export class AdminClaimService {
  private auth = inject(Auth);

  /**
   * True when the signed-in user's ID token carries `admin: true`.
   * Pass `refresh = true` to force a token refresh (claims are cached in the
   * token for up to an hour after they change).
   */
  async hasAdminClaim(refresh = false): Promise<boolean> {
    const user = this.auth.currentUser;
    if (!user) return false;
    const result = await getIdTokenResult(user, refresh);
    return result.claims['admin'] === true;
  }
}
